import { render, staticRenderFns } from "./BillForms.vue?vue&type=template&id=3e05290a&scoped=true"
import script from "./BillForms.vue?vue&type=script&lang=js"
export * from "./BillForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e05290a",
  null
  
)

export default component.exports